import { render } from "./ProgramList.vue?vue&type=template&id=229d539a&ts=true"
import script from "./ProgramList.vue?vue&type=script&lang=ts"
export * from "./ProgramList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__